// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-7c2a957b] {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body[data-v-7c2a957b] {\r\n  padding-top: 0px;\n}\n[data-v-7c2a957b] :disabled {\r\n  color: blue !important;\n}\n[data-v-7c2a957b] .marqee {\r\n  top: -81px;\n}\r\n", ""]);
// Exports
module.exports = exports;
